module.exports = __webpack_public_path__ + "img/gt.db4cd44d.svg";